if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.handleDocumentKeyDown = this.onDocumentKeyDown.bind(this);
        this.refreshBackgroundInert = () => setExternalContentInert(this);
        this.handleOriginSectionUnload = this.onOriginSectionUnload.bind(this);
        this.disconnectVersion = 0;
      }

      connectedCallback() {
        this.disconnectVersion += 1;
        const originSection = this.closest('.shopify-section');
        if (originSection && !this.originSection) this.bindOriginSection(originSection);
        super.connectedCallback();
      }

      disconnectedCallback() {
        const disconnectVersion = ++this.disconnectVersion;
        queueMicrotask(() => {
          if (disconnectVersion !== this.disconnectVersion || this.isConnected) return;
          this.teardownProductModal();
        });
      }

      bindOriginSection(originSection) {
        if (this.originSection === originSection) return;
        this.unbindOriginSection();
        this.originSection = originSection;
        this.originSection.addEventListener('shopify:section:unload', this.handleOriginSectionUnload);
      }

      unbindOriginSection() {
        this.originSection?.removeEventListener('shopify:section:unload', this.handleOriginSectionUnload);
        this.originSection = null;
      }

      onOriginSectionUnload(event) {
        if (event.target !== this.originSection) return;
        this.teardownProductModal();
        this.remove();
      }

      hide() {
        if (!this.hasAttribute('open')) return;

        document.removeEventListener('keydown', this.handleDocumentKeyDown);
        this.backgroundObserver?.disconnect();
        removeExternalContentInert(this);
        const returnFocus = this.getReturnFocusElement();
        this.openedBy = returnFocus;
        super.hide();
        this.openerGalleryId = null;
        this.openerMediaId = null;
      }

      show(opener) {
        document.querySelectorAll('cart-drawer').forEach((drawer) => drawer.close());
        this.openerGalleryId = opener.closest('media-gallery')?.id;
        this.openerMediaId = opener.dataset.mediaId;
        super.show(opener);
        setExternalContentInert(this);
        this.backgroundObserver = this.backgroundObserver || new MutationObserver(this.refreshBackgroundInert);
        this.backgroundObserver.disconnect();
        this.backgroundObserver.observe(document.body, { childList: true, subtree: true });
        document.addEventListener('keydown', this.handleDocumentKeyDown);
        this.showActiveMedia();
      }

      getReturnFocusElement() {
        if (isElementVisible(this.openedBy)) return this.openedBy;
        if (!this.openerMediaId) return null;

        const selector = `.product__media-toggle[data-media-id="${CSS.escape(this.openerMediaId)}"]`;
        const gallery = this.openerGalleryId ? document.getElementById(this.openerGalleryId) : null;
        const galleryOpener = gallery?.querySelector(selector);
        if (isElementVisible(galleryOpener)) return galleryOpener;
        return Array.from(document.querySelectorAll(selector)).find(isElementVisible) || null;
      }

      teardownProductModal() {
        const wasOpen = this.hasAttribute('open');
        document.removeEventListener('keydown', this.handleDocumentKeyDown);
        this.backgroundObserver?.disconnect();
        removeExternalContentInert(this);
        removeTrapFocus(null, this);
        removeDocumentOverflowHidden(this, 'overflow-hidden');
        this.removeAttribute('open');
        this.openedBy = null;
        this.openerGalleryId = null;
        this.openerMediaId = null;
        this.moved = false;
        this.unbindOriginSection();
        if (wasOpen) window.pauseAllMedia();
      }

      onDocumentKeyDown(event) {
        if (event.code.toUpperCase() !== 'ESCAPE' || !this.hasAttribute('open')) return;
        event.preventDefault();
        this.hide();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
